import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-cta bg-white" data-id="element-94" data-mp="9lbg511q9bdl">
      <p className="bg-brand px-3 py-1.5 text-center font-sub text-sm font-semibold leading-tight text-white sm:text-base" data-id="element-95" data-mp="4m8msdv40tlg">
        Método de aprendizaje paso a paso
      </p>

      <div className="mx-auto max-w-2xl px-3 pb-4 pt-3 text-center sm:px-5" data-id="element-96" data-mp="xae9351taqne">
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="font-display text-[1.6rem] font-extrabold leading-[1.1] tracking-tight text-ink sm:text-4xl" data-id="element-97" data-mp="xb5w3rhcfg22">
          El sistema completo para aprender{' '}
          <span className="text-brand" data-id="element-98" data-mp="382fi9x3dfkj5">contabilidad práctica argentina</span>{' '}
          <span className="bg-cta px-1 text-white" data-id="element-99" data-mp="384s78u7jqv5p">desde cero</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.05
      }} className="mx-auto mt-2 max-w-xl text-sm leading-snug text-ink/80" data-id="element-100" data-mp="3j6fylr125fed">
          Aprendé a registrar operaciones contables, comprender impuestos y
          organizar las finanzas de un negocio —{' '}
          <strong className="font-bold text-ink" data-id="element-101" data-mp="30ggg5mzq2yjx">
            sin perderte entre cientos de tutoriales, trámites, planillas y
            explicaciones complicadas.
          </strong>
        </motion.p>

        <p className="mt-2 inline-block rounded-lg bg-brand px-3 py-1.5 font-display text-xs font-extrabold uppercase leading-tight tracking-wide text-white sm:text-sm" data-id="element-102" data-mp="2qlofuber9xlg">
          {PRODUCT_NAME} ·{' '}
          <span className="text-highlight" data-id="element-103" data-mp="2hjynn3d1uumm">6 Tomos + 5 Bonos</span>
        </p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.1
      }} className="mt-2 block overflow-hidden rounded-2xl border-4 border-brand bg-canvas" data-id="element-104" data-mp="2ljgzl9mw7vdb">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-105" data-mp="icrn2n3lyf7n" />
        </motion.a>

        <p className="mt-1.5 font-sub text-xs font-semibold leading-snug text-ink/80 sm:text-sm" data-id="element-106" data-mp="1azkv7qjbugro">
          {PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos
        </p>

        <div className="mt-2.5" data-id="element-107" data-mp="111yc0ruzw31w">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-108" data-mp="11152jj4nizg2">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>
          <p className="mt-2.5 text-xs font-semibold text-ink/80" data-id="element-109" data-mp="x37c6cz5a7b3">
            Acceso Digital Inmediato • Garantía de 7 Días
          </p>
        </div>
      </div>
    </header>;
}